import Swagger from 'swagger-client';
import spec from '../data/project_ui_api';

const config = {
    // host: process.env.API_HOST || spec.host || '10.120.6.34:8081',
    host: process.env.API_HOST || spec.host || 'localhost:8081',
    basePath: process.env.API_BASE_PATH || spec.basePath || '/api'
  };

  const swaggerClient = () =>
  Swagger({
    spec,
    requestInterceptor: request => {
      request.headers['Content-Type'] = 'application/json;charset=UTF-8';
      request.url = `//${config.host}${config.basePath}${request.url}`;
      console.log(request.url);
      return request;
    }
  });

export default swaggerClient;



// WEBPACK FOOTER //
// ./src/utility/swaggerProjectClient.js